export default __webpack_public_path__ + "static/media/star.1c8c9a24.svg";